import { defineNuxtPlugin } from '#imports';
import authDirective from '@core/directives/auth';
import loginDirective from '@core/directives/login';
import trackDirective from '@core/directives/track';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('auth', authDirective);
  nuxtApp.vueApp.directive('login', loginDirective);
  nuxtApp.vueApp.directive('track', trackDirective);
});
